import React from 'react';
import moment from 'moment';
import { message } from 'antd';

import { CLIENTE_VARIOS } from '../../../common/types/clienteType';
import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { RETENCION } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { RUC, OTROS } from '../../../common/types/tipoDocumentoType';
import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    VENTA_MODIFICAR_TOTAL_PRODUCTO,
    EMPRESA_GRIFO,
    VENTA_REPORTE_TICKET,
} from "../../../common/types/parametroType";
import printFormatMock from '../../../common/mock/printFormatMock';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import { lst_pendiente_pagos } from "../../../common/types/pendientePagoType";

import proyectoService from '../../../service/administracion/proyectoService';
import retencionService from '../../../service/ventas/retencionService';

import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import detraccionService from '../../../service/administracion/detraccionService';
import proveedorService from '../../../service/administracion/proveedorService';
import comprobanteService from '../../../service/ventas/comprobanteService';
import metodoPagoservice from '../../../service/administracion/metodoPagoService';
import cuentaService from '../../../service/administracion/cuentaService';
import compraService from "../../../service/logistica/compraService";


import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import EditarNombreProductoModal from '../Seguimiento/EditarNombreProductoModal';
import ImprimirModal from './ImprimirModal';
import CorreoModal from './CorreoModal';
import ViewModal from './ViewModal';
import DetalleModal from './DetalleModal';
import ImportarModal from './ImportarModal';
import CdrModal from './CdrModal';



var referenciaCount = 1;

export default class Index extends PaginationBase {
    _isMounted = false;
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            loadingNew: false,
            loadingSource: true,
            loadingCopy: false,
            cdrVisible: false,

            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            pendientePago: lst_pendiente_pagos,
            proyectos: [],
            metodosPagos: [],
            cuentas: [],
            caja: [],
            selectedItem: {},
            filter: {
                idTipoComprobante: RETENCION.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                documento: '',
                idProveedor: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: []
            },
            editarNombreProductoFormValues: {
                id: '',
                nombre: ''
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },
            emitirVisible: false,
            importarCompraVisible: false,
            emitirFilePdf: undefined,
            imprimirVisible: false,
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values
            },
            correoFormValues: {
                file: undefined,
                id: 0,
                correoCliente: '',
                serie: '',
                documento: '',
                cliente: '',

            },
            importarCompra: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },
            cdrVisible: false,
            selectedItem: {},
            viewVisible: false,
            viewFormValues: {},
            importarVisible: false,
            importarFormValues: {
                dataSource: []
            },
            idCotizacionImportado: 0,
            formValuesDetalle: this.fetchEmptyFormDetalleValues(),

        }
    };

    fetchEmptyFormDetalleValues = () => {
        return {
            tipoComprobante: 'FACTURA ELECTRÓNICA',
            serie: '',
            numero: '',
            fechaEmision: global.fetchCurrentDateStr(),
            moneda: 0,
            cuota: 0,
            tipoCambio: 0,
            total: 0,
            fechaRetencion: global.fetchCurrentDateStr(),
            totalRetencion: 0,
            totalPagar: 0,
            totalPagado: 0
        }
    }

    fetchEmptyFormValues = (objEdit) => {
        return {
            id: objEdit !== undefined ? objEdit.retencion.id : 0,
            idTipoComprobante: RETENCION.ID,
            idProveedor: objEdit !== undefined ? objEdit.retencion.idProveedor : 0,
            idEstablecimientoCliente: objEdit !== undefined ? objEdit.retencion.idEstablecimientoProveedor : 0,
            // idProyecto: 0
            idProyecto: objEdit !== undefined ? objEdit.retencion.idProyecto : 0,
            // idComprobanteEstado: 0,
            idEstablecimiento: objEdit !== undefined ? objEdit.retencion.idEstablecimiento : 0,
            idDetraccion: 0,
            idUsuarioRegistro: auth.user().id,
            serie: objEdit !== undefined ? objEdit.retencion.serie : "",
            documento: objEdit !== undefined ? objEdit.retencion.documento : "",
            fechaStr: objEdit !== undefined ? objEdit.retencion.fechaStr : global.fetchCurrentDateStr(),
            numeroPlaca: "",
            tipoCambio: objEdit !== undefined ? objEdit.retencion.tipoCambio : 0,
            observacion: objEdit !== undefined ? objEdit.retencion.observacion : "",
            idMoneda: objEdit !== undefined ? objEdit.retencion.idMoneda : 1,
            tasa: objEdit !== undefined ? objEdit.retencion.tasa : 3,

            // flagAnticipo: false,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            listaComprobanteMetodoPago: [],

            /*********************/
            sumaSubTotal: objEdit !== undefined ? objEdit.retencion.totalRetencion : 0,

            sumaTotal: objEdit !== undefined ? objEdit.retencion.total : 0,

            activeKey: "1",
            documentoCliente: objEdit !== undefined ? objEdit.retencion.numeroDocumentoCliente : "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],


            proyectos: []
        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: RETENCION.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await retencionService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de retencions.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await retencionService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de retencions.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await retencionService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }
    handleImprimir = async (item) => {
        var file = undefined;
        var idFormato = 1; //auth.user().parametros.filter(m => m.abreviatura === VENTA_REPORTE_TICKET)[0].valor === "0" ? 1 : 2;
        var response;
        if (idFormato === 1) {
            response = await retencionService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await retencionService.ticket({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                fileName: item.serie + '-' + item.documento,
                idComprobante: item.id
            }
        });
    };

    handleCorreo = async (item) => {
        // var response = await retencionService.pdfA4({ id: item.id });
        var file = null;// window.URL.createObjectURL(response.data);

        this.setState({
            correoVisible: true,
            correoFormValues: {
                ...this.state.correoFormValues,
                file,
                id: item.id,
                correoCliente: item.correoCliente,
                serie: item.serie,
                documento: item.documento,
                cliente: item.razonSocialCliente,
            }
        });
    };

    handleEnviarCorreo = async (data, form) => {
        dialog.confirm('¿Desea enviar el correo?', async () => {
            var response = await retencionService.enviarCorreo(data);

            if (response.status === 200) {
                form.resetFields();
                dialog.success('El correo ha sido enviado.');
                this.setState({ correoVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleView = async (item) => {
        var response = await retencionService.ver({ id: item.id });
        if (response !== undefined) {
            this.setState({
                viewVisible: true,
                viewFormValues: response
            });
        }
    }


    contieneErroresSunat = (str) => {
        return ['1033', 'SendTimeout'].some(sub => str.includes(sub));
    };

    handleOpenCdrModal = async (row) => {

        row.respuestaSunat = row.respuestaSunat && this.contieneErroresSunat(row.respuestaSunat)
            ? null
            : row.respuestaSunat;

        this.setState({
            cdrVisible: true,
            selectedItem: row,
        });
    };


    handleDownloadXml = async () => {
        var response = await retencionService.xml({
            id: this.state.selectedItem.id,
        });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreXML);
    };

    handleDownloadCdr = async () => {
        var response = await retencionService.cdr({
            id: this.state.selectedItem.id,
        });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreCDR);
    };

    /******************** FORM MODAL *****************/

    handleEdit = async (item) => {
        const response = await retencionService.obtenerPorId(item.id);
        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }

        var formValues = this.fetchEmptyFormValues(response);
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.establecimientos;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.clientes = this.state.clientes;
        formValues.monedas = this.state.monedas;

        const direcciones = await establecimientoService.listarPorIdEntidad(response.retencion.idEntidadCliente);

        response.retencionDetalles.forEach(row => {
            const identifier = global.fetchUniqueCode();
            formValues.listaComprobanteDetalle.push(
                {
                    identifier: identifier,
                    tipoComprobante: "",
                    serie: row.serie,
                    documentoSerie: row.documentoSerie,
                    documento: row.documento,
                    fechaEmision: row.fechaEmision,
                    idMoneda: row.idMoneda,
                    tipoCambio: row.tipoCambio,
                    tipoComprobante: row.tipoComprobante,
                    total: row.total,
                    cuota: row.cuota,
                    idTipoComprobante: row.idTipoComprobante,
                    fechaRetencion: row.fechaRetencion,
                    totalRetencion: row.totalRetencion,
                    totalPagar: row.totalPagar,
                    totalPagado: row.totalPagado
                }
            );
        });

        this.setState({
            // loadingNew: false,
            visible: true,
            formValues,
            //productos: productos ? productos : []
        });
        this.setState({
            formValues: {
                ...this.state.formValues,
                direcciones: direcciones ? direcciones : [],
                // almacenes: almacenes ? almacenes : []
            }
        });


    }


    handleNew = async () => {
        this.setState({ loadingNew: true });

        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = this.state.clientes;
        formValues.proyectos = this.state.proyectos;
        formValues.pendientePago = this.state.pendientePago;

        formValues.metodosPagos = this.state.metodosPagos;
        formValues.cuentas = this.state.cuentas;
        formValues.caja = this.state.caja;


        const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: RETENCION.ID
        }
        debugger
        const datosIniciales = await retencionService.datosIniciales(datosInicialesFilter);

        if (datosIniciales !== undefined) {
            formValues.idVendedor = datosIniciales.idVendedor;
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.idListaPrecio = datosIniciales.idListaPrecio;
            formValues.serie = datosIniciales.serie;
            formValues.idCaja = datosIniciales.idCaja;


        }

        if (formValues.idEstablecimiento > 0) {
            const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
            formValues.almacenes = almacenes ? almacenes : [];
            formValues.listasPrecio = listasPrecio ? listasPrecio : [];
        }


        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

            }, 100);

        } else {

            this.setState({
                loadingNew: false,
                visible: true,
                formValues,
                productos: productos ? productos : []
            });
        }


    };

    handleSave = async (item, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            debugger

            item.idCotizacion = this.state.idCotizacionImportado;

            if (item.id === 0)
                response = await retencionService.registrar(item);
            else
                response = await retencionService.modificar(item);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((item.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };

    handleChangeForm = async (property, value, form) => {

        if (property === "fechaStr") {
            const fecha = moment(value, 'DD/MM/YYYY');
            const fechaVencimiento = moment(form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            form.setFieldsValue({
                tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString()
            });
        }


        if (property === "idProveedor") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoCliente: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }




        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idProveedor: undefined,
                    idEstablecimientoCliente: undefined,
                    documentoCliente: '',
                    direcciones: []
                }
            })
        }


    };

    handleChangeDetalle = async (data, form) => {
        var detalle = [];
        detalle.push(data)
        var items = detalle;

        var totalPago = parseFloat(items.reduce((a, b) => a + (b["totalPagado"] || 0), 0));
        var totalRetencion = parseFloat(items.reduce((a, b) => a + (b["totalRetencion"] || 0), 0));

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: items,
                detalleProductos: [],
                sumaTotal: totalPago,
                sumaSubTotal: totalRetencion

            }
        })

        form.resetFields();



    };
    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await retencionService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await retencionService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file
            }
        });
    };

    handleDownloadPdf = async () => {
        debugger
        var response = undefined;
        var file = undefined;

        if (this.state.imprimirFormValues.idFormato === 1) {
            response = await retencionService.pdfA4({
                id: this.state.imprimirFormValues.idComprobante,
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 2) {
            response = await retencionService.ticket({
                id: this.state.imprimirFormValues.idComprobante,
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 3) {
            response = await retencionService.ticket50({
                id: this.state.imprimirFormValues.idComprobante,
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (response !== undefined)
            global.dowloadFile(
                response.data,
                this.state.imprimirFormValues.fileName + ".pdf"
            );
    };

    handleBuscarCliente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

        const response = await padronReducidoService.logistica_proveedor(value);

        if (response.status === 200) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: response.data.direcciones
                }
            }, () => {
                form.setFieldsValue({
                    clientes: response.data.proveedores,
                    idProveedor: response.data.proveedores.length > 0 ? { key: response.data.proveedores[0].id } : undefined,
                    idEstablecimientoCliente: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    clientes: [],
                    idProveedor: undefined,
                    idEstablecimientoCliente: undefined
                });
            });
        }
    };



    handleOpenSearchProductModal = async () => {

        // var lista_stock= response.productos.length > 0 ? response.productos.filter((m) => m.stock > 0):[]

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
            }
        });
    };


    handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        // dialog.confirm(
        //   "El total de la venta excede el monto máximo establecido ¿Desea continuar?",
        //   async () => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idMoneda === undefined) {
            message.warning('Por favor seleccione la moneda.');
            return;
        }

        if (idListaPrecio === undefined) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        /* PARAMETROS */
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV =
            params.filter(
                (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
                ? true
                : false;
        var porcentajeIGV = 18;

        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues
            .listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter(
            (m) => m.codigoBarra === value
        );

        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter(
                (m) => m.codigoBarra !== value
            );
            var item = filter_detalle[0];
            item.cantidad = item.cantidad + 1;
        } else {
            var filter = {
                idAlmacen: idAlmacen.key,
                idMoneda: idMoneda.key,
                idListaPrecio: idListaPrecio.key,
                codigoNombre: value,
            };

            var list = await productoService.stock(filter);
            var filter_list = list.productos.filter(
                (m) => m.codigoBarra === value
            );
            if (filter_list.length === 0) {
                alert("no existe el producto");
                return;
            }
            var row = filter_list[0];

            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                idTipoProducto: row.idTipoProducto,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                precioPromedio: row.precioPromedio,
                flagAfecto: row.flagIGVAfecto,
                flagGratuito: row.flagGratuito,
                flagISC: row.flagISC,
                flagExonerado: row.flagExonerado,
                isc: 0,
                precioUnitario: row.precioUnitario,
                cantidad: 1,
                totalDetalle: 0,
                porcentajeDescuento: 0,
                importeDescuento: 0,
                subTotal: 0,
                igv: 0,
                total: 0,
                numeroLote: row.numeroLote,
                stock: row.stockDisponible,
            };
        }

        /* CALCULOS */
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
        item.precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? item.precioUnitario / divisorCalculoSubTotal
            : item.precioUnitario;
        item.totalDetalle = item.cantidad * item.precioUnitarioSinIGV;
        item.subTotal = item.cantidad * item.precioUnitarioSinIGV;
        item.igv = parseFloat(
            item.flagAfecto ? item.subTotal * (porcentajeIGV / 100) : 0
        );
        item.total = item.subTotal + item.igv;
        /* CALCULOS */

        listaComprobanteDetalle.push(item);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    idTipoProducto: item.idTipoProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    porcentajeMargenComercial: item.porcentajeMargenComercial,
                    precioPromedio: item.precioPromedio,
                    precioUnitario: item.precioUnitario,
                    porcentajeDescuento: item.porcentajeDescuento,
                    importeDescuento: item.importeDescuento,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagISC: item.flagISC,
                    flagOtrosImpuesto: false,
                    flagGratuito: item.flagGratuito,
                    flagChangeTotal: false,
                    subTotal: 0,
                    numeroLote: item.numeroLote,
                };


                var detalleProductos = this.state.onGetFieldValue(
                    "detalleProductos"
                );
                detalleProductos = detalleProductos.filter(
                    (m) => m.identifier !== producto.identifier
                );
                detalleProductos.push(producto);
                this.state.onSetFieldsValue({
                    sumaTotalDetalle: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["totalDetalle"] || 0),
                        0
                    ),
                    sumaSubTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["subTotal"] || 0),
                        0
                    ),
                    sumaIgv: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["igv"] || 0),
                        0
                    ),
                    sumaTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["total"] || 0),
                        0
                    ),
                    detalleProductos: detalleProductos,
                });
            }
        );
        //   }
        // );
    };

    handleRemoverProducto = (row, form) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: []
            },
        }, () => {
            form.setFieldsValue({
                detalleProductos: []
            });
        });
    };

    handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: row.identifier,
            nombre: onGetFieldValue(`arrNombre[${row.identifier}]`)
        };

        this.setState({
            editarNombreProductoVisible: true,
            editarNombreProductoFormValues: formValues,
            onSetFieldsValue,
            onGetFieldValue
        });
    };

    handleSaveEditarNombreProducto = (values, form) => {
        form.resetFields();
        this.setState({ editarNombreProductoVisible: false });
        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos.forEach(item => {
            if (item.identifier === values.id) {
                item.nombre = values.nombre;
                return;
            }
        });

        this.state.onSetFieldsValue({
            detalleProductos,
            [`arrNombre[${values.id}]`]: values.nombre
        });
    };


    handleSelectCompra = async (values) => {
        var detalle = [];
        this.state.formValues.listaComprobanteDetalle = detalle;

        const total = Number(values.total) || 0;
        const tasa = Number(this.state.formValues.tasa) || 0;
        const tipoCambio = Number(this.state.formValues.tipoCambio) || 1;

        const esDolares = values.idMoneda === DOLARES_AMERICANOS;

        // Calcular retención base
        let totalRetencion = total * (tasa / 100);

        // Aplicar tipo de cambio solo si es dólares
        if (esDolares) {
            totalRetencion *= tipoCambio;
        }

        // Calcular pago
        let totalPago = total - (esDolares ? totalRetencion / tipoCambio : totalRetencion);

        if (esDolares) {
            totalPago *= tipoCambio;
        }

        const data = {
            identifier: global.fetchUniqueCode(),
            id: values.id ?? 0,
            tipoComprobante: values.tipoDocumento,
            serie: values.serie?.toUpperCase(),
            documentoSerie: `${values.serie?.toUpperCase()}-${values.documento}`,
            documento: values.documento,
            fechaEmision: values.fechaEmision ? moment(values.fechaEmision).format("DD/MM/YYYY") : null,
            idMoneda: values.idMoneda,
            tipoCambio: 0,
            cuota: 1,
            total,
            totalRetencion,
            totalPagado: totalPago,
            idTipoComprobante: values.idTipoDocumento
        };

        detalle.push(data);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: detalle,
                detalleProductos: [],
                sumaTotal: data.totalPagado,
                sumaSubTotal: data.totalRetencion

            }
        })

        this.state.onSetFieldsValue({
            [`sumaSubTotal`]: data.totalRetencion,
            [`sumaTotal`]: data.totalPagado

        });

    };



    handleImportarCompra = async (onSetFieldsValue, onGetFieldValue) => {

        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, async () => {
            var idProveedor = this.state.onGetFieldValue('idProveedor');
            if (idProveedor === undefined) {
                dialog.error("Debe seleccionar un Proveedor");
                return false;
            }
            var filter = {
                idProveedor: idProveedor === undefined ? 0 : idProveedor.key,
                serie: '',
                documento: '',
            }

            var newData = await compraService.importarRetencion(filter);

            this.setState({
                importarCompraVisible: true,
                importarCompra: {
                    ...this.state.importarCompra,
                    dataSource: newData ? newData : []
                },
            });


        });
    };


    handleChangeTab = (key, onSetFieldsValue) => {
        if (key == "2") { // Referencias
            onSetFieldsValue({
                flagReferencia: true
            })
        }

        if (key == "4") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();
        });
    };


    handleAnular = async (item) => {
        dialog.confirm(`¿Desea anular el retencion ${item.serie}-${item.documento}?`, async () => {
            var response = await retencionService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(`retencion ${item.serie}-${item.documento} anulado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEmitir = async (item) => {
        dialog.confirm(`¿Desea emitir el retencion ${item.serie}-${item.documento}?`, async () => {
            var response = await retencionService.emitir({ id: item.id });

            if (response.status === 200) {
                dialog.success(`retencion ${item.serie}-${item.documento} emitido correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.success('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };




    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: RETENCION.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }




    async componentDidMount() {
        this._isMounted = true;

        const datosIniciales = await this.obtenerDatosIniciales();
        const serie = [undefined, null].includes(datosIniciales?.serie) ? '' : datosIniciales.serie;
        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination({ ...this.state.filter, serie }, retencionService.paginacion);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const detracciones = await detraccionService.listar();
        const clientes = await proveedorService.listar();
        const proyectos = await proyectoService.listar();

        const metodosPagos = await metodoPagoservice.listar();
        const cuentas = await cuentaService.listar();

        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
                monedas: monedas ? monedas : [],
                listasPrecio: listasPrecio ? listasPrecio : [],
                establecimientos: establecimientos ? establecimientos : [],
                vendedores: vendedores ? vendedores : [],
                tiposComprobante: tiposComprobante ? tiposComprobante : [],
                detracciones: detracciones ? detracciones : [],
                clientes: clientes ? clientes : [],
                proyectos: proyectos ? proyectos : [],
                metodosPagos: metodosPagos ? metodosPagos : [],
                cuentas: cuentas ? cuentas : [],

            });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    };

    render() {
        return (
            <div>
                <Header
                    title="Retención"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    lista_clientes={this.state.clientes}

                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingCopy={this.state.loadingCopy}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    //onPrint={this.handlePrint}
                    //onExportExcel={this.handleExportExcel}
                    //onExportPdf={this.handleExportPdf}
                    onCdr={this.handleOpenCdrModal}
                    onEdit={this.handleEdit}
                    onChange={this._handleChangePagination}
                    onView={this.handleView}
                    onEmitir={this.handleEmitir}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                    onCorreo={this.handleCorreo}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarCliente={this.handleBuscarCliente}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onImportarCompra={this.handleImportarCompra}

                    onScanerProduct={this.handleScanerProduct}
                />


                <DetalleModal
                    formValues={this.state.formValuesDetalle}
                    tipoCambio={this.state.formValues.tipoCambio}

                    visible={this.state.searchProductVisible}
                    onClose={() => this.setState({ searchProductVisible: false })}
                    onChange={(e) => { }}
                    listaMoneda={this.state.monedas}
                    handleDetalleOk={this.handleChangeDetalle}
                />

                <EditarNombreProductoModal
                    visible={this.state.editarNombreProductoVisible}
                    formValues={this.state.editarNombreProductoFormValues}
                    onClose={() => this.setState({ editarNombreProductoVisible: false })}
                    onSave={this.handleSaveEditarNombreProducto}
                />

                <ImportarModal
                    tittle="Búsqueda de Compra"
                    visible={this.state.importarCompraVisible}
                    formValues={this.state.importarCompra}
                    onSelect={this.handleSelectCompra}
                    onClose={() => this.setState({ importarCompraVisible: false })}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}

                    onClose={() => this.setState({ imprimirVisible: false })}
                />
                <CorreoModal
                    visible={this.state.correoVisible}
                    formValues={this.state.correoFormValues}
                    onClose={() => this.setState({ correoVisible: false })}
                    onSend={this.handleEnviarCorreo}
                />
                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                />

                <CdrModal
                    visible={this.state.cdrVisible}
                    loadingFile={this.state.loadingFile}
                    item={this.state.selectedItem}
                    onDownloadXml={this.handleDownloadXml}
                    onDownloadCdr={this.handleDownloadCdr}
                    onGetCdr={this.handleGetCdr}
                    onClose={() => this.setState({ cdrVisible: false })}
                />
            </div>
        )
    }
}